"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Thumb = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const context_2 = require("./context");
const useSyncStore_1 = require("../../hooks/useSyncStore");
const MAX_BORDER_RADIUS = 4;
const thumbClass = (0, nano_theme_1.drule)({
    pos: 'absolute',
    l: 0,
    r: 0,
    bdrad: '4px',
    trs: 'background 0.1s ease',
    us: 'none',
    cur: 'ns-resize',
});
const Thumb = ({ children, className, style, ...rest }) => {
    const state = (0, context_2.useScrollArea)();
    const styles = (0, context_1.useStyles)();
    (0, useSyncStore_1.useSyncStore)(state.scrollRatio$);
    (0, useSyncStore_1.useSyncStore)(state.thumbRatio$);
    const canScroll = (0, useSyncStore_1.useSyncStore)(state.canScroll$);
    const dragging = (0, useSyncStore_1.useSyncStore)(state.dragging$);
    const railDragging = (0, useSyncStore_1.useSyncStore)(state.railDragging$);
    const railEl = state.railEl;
    const railHeight = railEl ? railEl.clientHeight : 0;
    const thumbH = state.thumbHeight(railHeight);
    const thumbT = state.thumbTop(railHeight);
    if (!canScroll)
        return null;
    const isDragging = dragging || railDragging;
    const topBorderRadius = Math.min(MAX_BORDER_RADIUS, thumbT / 3);
    const bottomBorderRadius = Math.min(MAX_BORDER_RADIUS, (railHeight - thumbT - thumbH) / 3);
    const computedStyle = {
        height: thumbH,
        transform: `translate3d(0, ${thumbT}px, 0)`,
        borderRadius: `${topBorderRadius}px ${topBorderRadius}px ${bottomBorderRadius}px ${bottomBorderRadius}px`,
        ...style,
    };
    if (typeof children === 'function') {
        return (React.createElement("div", { ref: state.setThumb, onPointerDown: state.onThumbPointerDown, onPointerMove: state.onThumbPointerMove, onPointerUp: state.onThumbPointerUp }, children(computedStyle, state)));
    }
    return (React.createElement("div", { ...rest, ref: state.setThumb, className: thumbClass({ bg: styles.g(0, isDragging ? 0.48 : 0.24), '&:hover': { bg: styles.g(0, 0.48) } }) +
            (className ? ' ' + className : ''), style: computedStyle, onPointerDown: state.onThumbPointerDown, onPointerMove: state.onThumbPointerMove, onPointerUp: state.onThumbPointerUp }));
};
exports.Thumb = Thumb;
